import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="segment-save"
// Prompts for a segment name on button click, then submits the form.
export default class extends Controller {
  confirmName(event) {
    event.preventDefault()
    const nameField = this.element.querySelector('input[name="name"]')
    const name = window.prompt("Name this segment:")
    if (!name || !name.trim()) return
    if (nameField) nameField.value = name.trim()
    this.element.requestSubmit()
  }
}
